export default __webpack_public_path__ + "static/media/cassette.9bf4bb9d.png";